import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Footer } from "../../../layout/footer/footer.component";
import { NormalNavbar } from "../../../layout/normal-navbar/normal-navbar";
import { SeoService } from '../../../core/services/seo/seo.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterModule, NormalNavbar, Footer],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss'
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 0);
    }
    this.seoService.setSeo({
      title: 'Privacy Policy',
      description: 'Scenetale Cinema Privacy Policy — information on cookies, Google AdSense, third-party data practices, and user privacy rights.',
      url: '/privacy-policy',
      type: 'website'
    });
  }
}
